module.exports = __webpack_public_path__ + "static/media/icon-instagram.3917c813.svg";